module.exports = __webpack_public_path__ + "75368062f82f68e115d3f40a8c113b3d.webp";